import { useSubscriptionEvent } from '@confluence/graphql/entry-points/useSubscriptionEvent';
import { fg } from '@confluence/feature-gating';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';
import { expVal } from '@confluence/feature-experiments';

type useContentRestrictionSubscriptionEventProps = {
	callback: (data?: any) => void;
	subscriberId: string;
	contentId: string;
	contentType: string;
};

export const useContentRestrictionSubscriptionEvent = ({
	callback,
	subscriberId,
	contentId,
	contentType,
}: useContentRestrictionSubscriptionEventProps) => {
	useSubscriptionEvent({
		onDataReceived: callback,
		delta: 'contentRestrictionUpdated',
		subscriberId,
		contentType,
		contentId,
		skip:
			// eslint-disable-next-line confluence-feature-gating/no-preconditioning
			!expVal('cc_fps_migration_content-restriction-updated', 'isEnabled', false) ||
			!fg('confluence_enable_subscriptions-context-provider') ||
			!['DUAL', 'GRAPHQL'].includes(
				StatsigConfigurations.getString('confluence-migrate-fps-to-graphql-subscription', ''),
			),
	});
};
